import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Spacer, TextCapitalized } from "@qivia/ui";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { ButtonDS } from "@qivia/ui/src/designSystem/components/Button";
import { MessageTooltip } from "@qivia/ui/src/designSystem/components/MessageTooltip";
import { TaskAltOutlined } from "@qivia/ui/src/designSystem/materialUi/materialUi";
import { Page } from "../../components/Page";
import { RestitutionSummaryContent } from "../shared/restitutionSummaryContent";
import "../../../i18n/i18n";

interface RestitutionValidationStepProps {
  mileage: number;
  isCabinCleaned: boolean;
  isTrunkCleaned: boolean;
  observations: string;
  oldPictures: { uuid: string; url: string }[];
  newPictures: File[];
}

export const RestitutionValidationStep = (
  props: RestitutionValidationStepProps,
) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Page
      title={
        <StyledHeader>
          <StyledCheckIcon>
            <TaskAltOutlined />
          </StyledCheckIcon>
          <Spacer y={0.5} />
          <TextCapitalized>
            {t("restitution.checkDeclared.title")}
          </TextCapitalized>
        </StyledHeader>
      }
      withoutHeaderSpacer
      centerHeader
      helpButton
      bottomButtonBackgroundColor="white"
      withShadow
      bottomButton={
        <ButtonDS
          text={t("restitution.checkDeclared.button.backToMenu")}
          buttonType="primary"
          format="fill"
          onClick={() => navigate("/menu")}
        />
      }
    >
      <StyledForm>
        <Spacer y={1} />
        <StyledBanner>
          <MessageTooltip
            type="SUCCESS"
            title={t("restitution.summary.subtitle.title")}
            text={t("restitution.summary.subtitle.text")}
            iconLeft={<TaskAltOutlined />}
          />
        </StyledBanner>
        <Spacer y={1.5} />
        <StyledSeparator />
        <Spacer y={1.5} />
        <RestitutionSummaryContent
          mileage={props.mileage}
          isCabinCleaned={props.isCabinCleaned}
          isTrunkCleaned={props.isTrunkCleaned}
          observations={props.observations}
          oldPictures={props.oldPictures}
          newPictures={props.newPictures}
        />
      </StyledForm>
    </Page>
  );
};

const StyledForm = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const StyledHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const StyledCheckIcon = styled.div`
  display: flex;
  & svg {
    width: 3rem;
    height: 3rem;
    fill: ${colors["colors/system/success/success_normal"]};
  }
`;

const StyledBanner = styled.div`
  width: 100%;
  & > div {
    box-sizing: border-box;
  }
`;

const StyledSeparator = styled.div`
  width: 100%;
  border-bottom: 0.0625rem solid ${colors["colors/borders/separator/cells"]};
`;

